<template>
  <div :class="ns.b()" :style="style">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@zoryn/hooks'
import type { CSSProperties } from 'vue'
import type { DashboardProps } from './dashboard'

defineOptions({
  name: 'ZDashboard',
})

const props = withDefaults(defineProps<DashboardProps>(), {
  maxWidth: '1280px',
})

const ns = useNamespace('dashboard')
const style = computed(
  () =>
    ({
      maxWidth: props.maxWidth,
    }) as CSSProperties
)
</script>
